import React, { Component } from 'react';
import '../css/App.css';
import { observer } from 'mobx-react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import HomeIcon from '@material-ui/icons/Home';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    root: {
      flexGrow: 1, 
      height: "44px"           
    },
    appbar:{
      backgroundColor: '#FFF',
      height: "44px",
      boxShadow: "0px 2px 2px #DDD",        
    },
    toolbar:{
      minHeight: "44px",
      padding: 0,
    },
    title: {
      flexGrow: 1,
      textAlign: 'center',
      fontSize: "17px",
      fontFamily: 'Noto Sans TC, sans-serif',
      color: '#333'
    },
    menuButton: {
      color: '#333'
    },
};

class Appbar extends Component { 

  goHome=(e)=>{
    window.location.href = /m/    
  }
  
    
  render() {
    const { classes } = this.props;
    return (            
        <div className={classes.root}>
        <AppBar position="static" className={classes.appbar}>
          <Toolbar className={classes.toolbar}>
            <IconButton 
                className={classes.menuButton} 
                color="inherit" 
                aria-label="Menu"  
                onClick={this.goHome}         
            >
                <KeyboardArrowLeftIcon/>
            </IconButton>
            <Typography variant="h6" color="inherit" className={classes.title}>
              線上捐款
            </Typography>
            <IconButton 
                className={classes.menuButton} 
                color="inherit" 
                aria-label="Menu"
                onClick={this.goHome}
            >
                <HomeIcon/>
            </IconButton>
          </Toolbar>
        </AppBar>
      </div>  
    );
  }
}

export default withStyles(styles)(observer(Appbar));
